import axios from "axios";
import { AES, enc } from 'crypto-js';
import "./VendorInviteRegister.css";
import "cropperjs/dist/cropper.css";
import { toast } from "react-toastify";
import { useDispatch } from 'react-redux';
import 'react-phone-number-input/style.css';
import "react-toastify/dist/ReactToastify.css";
import PhoneInput from 'react-phone-number-input';
import Tele from "../../../images/icons/tele.svg";
import Countries from "../../../constants/countries";
import CompanyUrl from "../../../images/icons/webpage.svg"
import EmailIcon from "../../../images/icons/email.svg";
import Tick from "../../../images/icons/tick-arrow.svg";
import location from "../../../images/icons/location.svg";
import React, { useEffect, useRef, useState } from "react";
import PostalCode from "../../../images/icons/postal-code.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import { logout, reset } from "../../../features/auth/authSlice";
import profile_image from "../../../images/user/Default_pfp.png";
import PicEdit from "../../../images/icons/profile-pic-edit.svg";
import UserIcon from "../../../images/icons/single-user-icon.svg";
import { reset as invoiceReset } from "../../../features/invoice/invoiceSlice.js";
import { reset as headerReset } from "../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../features/appSettings/appSettingsSlice.js";
import { getBrandLogo, getBrandLogoAlt } from "../../../utils/brandLogo";

// Skeleton loader styles
const skeletonStyle = {
  backgroundColor: "#e5e7eb",
  borderRadius: "4px",
  animation: "pulse 1.5s ease-in-out infinite",
};

// Edit Icon Skeleton
const EditIconSkeleton = () => (
  <div
    style={{
      width: "29px",
      height: "29px",
      borderRadius: "50%",
      ...skeletonStyle,
    }}
  />
);

// Button Skeleton (for Save changes button)
const ButtonSkeleton = () => (
  <div
    style={{
      width: "140px",
      height: "38px",
      backgroundColor: "rgba(255, 255, 255, 0.3)",
      borderRadius: "6px",
      animation: "pulse 1.5s ease-in-out infinite",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      boxSizing: "border-box",
    }}
  >
    <div
      style={{
        width: "100px",
        height: "18px",
        backgroundColor: "rgba(255, 255, 255, 0.6)",
        borderRadius: "4px",
        animation: "pulse 1.5s ease-in-out infinite",
      }}
    />
  </div>
);

export default function VendorInviteRegisteration() {
  const dispatch = useDispatch();
  const { venInvEmail, encodedAppId } = useParams();
  const fileInputRef = useRef(null);
  const [vendorName, setVendorName] = useState("");
  const [companyWebsite, setCompanyWebsite] = useState("");
  const [isValidUrl, setIsValidUrl] = useState(false);
  const [companyLogo, setCompanyLogo] = useState(null);
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [mobileNo, setMobileNo] = useState("");
  const [pincode, setPincode] = useState("");
  const [address, setAddress] = useState("");
  const [uploadedImageUrl, setUploadedImageUrl] = useState("");
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [fileSelectIsLoading, setFileSelectIsLoading] = useState(false);
  const [countrySearchTerm, setCountrySearchTerm] = useState('');
  const [countryDropdownOpen, setCountryDropdownOpen] = useState(false);
  const [countriesList, setCountriesList] = useState([]);
  const [stateSearchTerm, setStateSearchTerm] = useState("");
  const [stateDropdownOpen, setStateDropdownOpen] = useState(false);
  const countryDropdownRef = useRef(null);
  const stateDropdownRef = useRef(null);
  const decodedVenInvEmail = decodeURIComponent(
    atob(venInvEmail.replace(/\-/g, "+").replace(/_/g, "/"))
  );
  const decodedAppId = decodeURIComponent(encodedAppId.replace(/%2F/g, '/'));
  const decryptedBytes = AES.decrypt(decodedAppId, 'encryptionKey');
  const appId = decryptedBytes.toString(enc.Utf8);
  const navigate = useNavigate();
  useEffect(() => {

    const verifyResetPassLink = async () => {
      const { venInvEmail } = { venInvEmail: decodedVenInvEmail };
      try {
        const response = await axios.post("/api/vendor/check/vendor-invite/validity", { venInvEmail });
        if (response.data.status === "emailAlreadyRegistered") {
          // Reset link expired, redirect to forget-password page with alert message
          toast.error("This email is already registered.!!!", {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate("/");
        }
        if (response.data.status === "linkExpired") {
          // Reset link expired, redirect to forget-password page with alert message
          toast.error("Sorry!.Invite link expired", {
            position: "bottom-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          navigate("/");
        }
      } catch (error) {
        console.error(error);
        global.config.slackMessage(error.toString());
        toast.error("Something went wrong while verifying the reset link");
      }
    };
    verifyResetPassLink();

    const sortedCountries = Countries.slice().sort((a, b) => a.country.localeCompare(b.country));
    setCountriesList(sortedCountries);

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        document.activeElement.blur();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitLoading(true);
    setIsValidUrl(false);
    const mobileNoRegex = /^[+\d]+$/;
    const pattern = /^(ftp|http|https):\/\/[^ "]+$/;
    if (!mobileNoRegex.test(mobileNo)) {
      toast.error("It's not a valid phone number", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setIsSubmitLoading(false);
      return;
    }
    if (!pattern.test(companyWebsite)) {
      toast.error("It's not a valid URL.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setIsValidUrl(true);
      setIsSubmitLoading(false);
      return;
    }
    const requestData = {
      vendor_name: vendorName,
      email: decodedVenInvEmail,
      company_website: companyWebsite,
      mobile_no: mobileNo,
      address,
      country,
      state,
      acc_manager: null,
      contact_point: null,
      city,
      pincode,
      appId,
    };

    if (!requestData.appId) {
      toast.error("Something went wrong with the appId", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setIsSubmitLoading(false);
      return;
    }

    // Create a new FormData object
    const formData = new FormData();
    // Append the profile image to the form data
    formData.append("company_logo", companyLogo);

    // Append the other request data to the form data
    for (let key in requestData) {
      formData.append(key, requestData[key]);
    }

    try {
      const response = await axios.post("/api/vendor/invite/registration", formData);
      const data = response.data;
      if (data.status === "exists") {
        toast.warning("Vendor already exists", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (data.status === "error") {
        toast.error("Something went wrong", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.success("Your vendor account is registered successfully. Please check your email", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        navigate(`/`);
      }
    } catch (error) {
      console.log(error);
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error('This user is deleted!', {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      toast.error(`Error ${error.response?.data.message}`, {
        position: "bottom-right",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const handleProfilePicChange = () => {
    setFileSelectIsLoading(true);
    // Open file input dialog
    fileInputRef.current.click();
  };

  const handleFileInputCancel = () => {
    setFileSelectIsLoading(false);
  };

  useEffect(() => {
    const inputElement = fileInputRef.current;

    const handleChange = () => {
      handleFileInputChange({ target: { files: inputElement.files } });
    };

    const handleCancel = () => {
      handleFileInputCancel();
    };

    inputElement.addEventListener('change', handleChange);
    inputElement.addEventListener('cancel', handleCancel);

    return () => {
      inputElement.removeEventListener('change', handleChange);
      inputElement.removeEventListener('cancel', handleCancel);
    };
  }, []);

  const handleFileInputChange = (event) => {
    setFileSelectIsLoading(false);
    const file = event.target.files[0];
    setCompanyLogo(event.target.files[0])
    if (file) {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        setUploadedImageUrl(fileReader.result);
      };
      // if (removeProfileImage) {
      // setRemoveProfileImage(false);
      // }
      fileReader.readAsDataURL(file);
    }
  };

  const handleCountrySearchInputChange = (e) => {
    setCountrySearchTerm(e.target.value);
  };

  const filteredCountries = countriesList.filter((country) => {
    return country.country.toLowerCase().includes(countrySearchTerm.toLowerCase());
  });

  const countryData = countriesList.find((c) => c.country === country);
  const states = countryData?.states || [];

  const handleStateSearchInputChange = (e) => {
    setStateSearchTerm(e.target.value);
  };

  const selectedCountry = countriesList.find((c) => c.country === country);
  const filteredStates = selectedCountry?.states?.filter((stateObj) =>
    stateObj.state.toLowerCase().includes(stateSearchTerm.toLowerCase())
  );

  const handleClickOutsideDropdown = (event) => {
    const isClickInsideCountryDropdown = countryDropdownRef.current && countryDropdownRef.current.contains(event.target);
    const isClickInsideStateDropdown = stateDropdownRef.current && stateDropdownRef.current.contains(event.target);
    if (!isClickInsideCountryDropdown) {
      setCountryDropdownOpen(false);
    }
    if (!isClickInsideStateDropdown) {
      setStateDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutsideDropdown);
    return () => {
      document.removeEventListener('click', handleClickOutsideDropdown);
    };
  }, []);

  return (
    <>
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
      <div className="inviter-register-outer">
        <div className="inviter-register-left">
          <div className="logo-invite">
            <img src={getBrandLogo()} alt={getBrandLogoAlt()} />
          </div>
          <div className="title-regis-outer">
            <div className="title-regis-left">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 27 27" fill="none">
                <path d="M8 13.2667L11.8261 17L19 10" stroke="#405BFF" strokeWidth="2" />
                <circle cx="13.5" cy="13.5" r="12.5" stroke="#405BFF" strokeWidth="2" />
              </svg>
            </div>
            <div className="title-regis-right">
              <div className="title-regis-top">
                Registration
              </div>
              <div className="title-regis-bottom">
                Complete your regisration
              </div>
            </div>
          </div>
        </div>
        <div className="inviter-register-right">
          <div>
            <div className='tab-outer'>
              {/* <ul className="tabs">
                <li className='active-tab'>
                  Registration
                </li>
              </ul> */}
              <div className="tabs-content">
                <div className="profile-details-edit" >
                  <form onSubmit={handleSubmit}>
                    <div className="profile-photo-outer">
                      <div className="profile-photo">
                        <div className="profile-photo-inner">
                          <div className="profile-photo-sec">
                            {uploadedImageUrl ? (
                              <div className="profile-image">
                                <img src={uploadedImageUrl} alt="Uploaded Profile" />
                              </div>
                            ) : (
                              <div className="profile-image">
                                <img src={profile_image} alt="User Profile" />
                              </div>
                            )}

                            <div className="profile-pic-edit">
                              <a 
                                className="pic-edit" 
                                onClick={!fileSelectIsLoading ? handleProfilePicChange : undefined}
                                style={{
                                  pointerEvents: fileSelectIsLoading ? "none" : "auto",
                                  cursor: fileSelectIsLoading ? "not-allowed" : "pointer",
                                  opacity: fileSelectIsLoading ? 0.6 : 1,
                                }}
                              >
                                {fileSelectIsLoading ? (
                                  <EditIconSkeleton />
                                ) : (
                                  <img src={PicEdit} alt="edit" />
                                )}
                              </a>
                            </div>
                          </div>
                          <div className="profile-name">
                            <div className="profile-name-sec">
                              {vendorName ? vendorName : "Vendor Name"}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <input
                      type="file"
                      accept="image/*"
                      style={{ display: "none" }}
                      ref={fileInputRef}
                    />
                    <div className="information-outer-section">

                      <div className="information-inner">
                        <div className="information">
                          <div className="information-title">
                            Company Information
                          </div>
                          <div className="information-outer">
                            <div className="information-left">

                              <div className="inner-detail-outer">
                                <div className="inner-detail">
                                  <span className="icon"><img src={UserIcon} alt="user icon" /></span>
                                  <div className="inner-detail-inner">
                                    <label htmlFor="Cname">Commercial Name *</label>
                                  </div>
                                </div>
                                <div className="inner-detail">
                                  <span className="icon"></span>
                                  <div className="inner-detail-inner">
                                    <input
                                      type="text"
                                      placeholder="Enter Commercial name"
                                      value={vendorName}
                                      onChange={(e) => setVendorName(e.target.value)}
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="information-right">
                              <div className="inner-detail-outer">
                                <div className="inner-detail">
                                  <span className="icon"><img src={EmailIcon} alt="user icon" /></span>
                                  <div className="inner-detail-inner">
                                    <label htmlFor="email">Email</label>
                                  </div>
                                </div>
                                <div className="inner-detail">
                                  <span className="icon"></span>
                                  <div className="inner-detail-inner">
                                    <input
                                      type="email"
                                      placeholder="Email"
                                      value={decodedVenInvEmail}
                                      readOnly
                                      required
                                    />
                                  </div>
                                </div>
                              </div>


                              <div className="inner-detail-outer">
                                <div className="inner-detail">
                                  <span className="icon"><img src={CompanyUrl} alt="company-url" /></span>
                                  <div className="inner-detail-inner">
                                    <label htmlFor="password">Company Url *</label>
                                  </div>
                                </div>
                                <div className="inner-detail">
                                  <span className="icon"></span>
                                  <div className="inner-detail-inner pass-eye">
                                    <input
                                      type="text"
                                      placeholder="Company Url"
                                      value={companyWebsite}
                                      onChange={(e) => setCompanyWebsite(e.target.value)}
                                      required
                                    />
                                    {isValidUrl && (
                                      <span className="text-red-500 text-xs italic">
                                        Please enter a valid URL!!
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="information-inner">
                        <div className="information">
                          <div className="information-title">
                            Address
                          </div>
                          <div className="information-outer">
                            <div className="information-left">
                              <div className="inner-detail-outer">
                                <div className="inner-detail">
                                  <span className="icon">
                                    <img src={location} alt="Location Icon" />
                                  </span>
                                  <div className="inner-detail-inner">
                                    <label>Country *</label>
                                  </div>
                                </div>
                                <div className="inner-detail">
                                  <span className="icon"></span>
                                  <div className="inner-detail-inner">

                                    <div className={`custom-dropdown-user-new-outer custom-dropdown-select ${countryDropdownOpen ? 'open' : ''}`} ref={countryDropdownRef}>
                                      <div className="selected-option custom-dropdown-user-new" onClick={() => setCountryDropdownOpen(!countryDropdownOpen)} style={{ cursor: 'pointer' }}>
                                        {country ? countriesList.find((c) => c.country === country)?.country : 'Select Country'}
                                      </div>
                                      {countryDropdownOpen && (
                                        <div className="custom-dropdown-new">
                                          <input
                                            type="text"
                                            className="search-bar"
                                            placeholder="Search..."
                                            value={countrySearchTerm}
                                            onChange={handleCountrySearchInputChange}
                                          />
                                          <ul className="country-list">
                                            {filteredCountries.length > 0 &&
                                              filteredCountries.map((c) => (
                                                <li
                                                  key={c.country}
                                                  className={country === c.country ? 'selected-item' : ''}
                                                  onClick={() => {
                                                    setCountry(c.country);
                                                    setCountryDropdownOpen(false);
                                                  }}
                                                >
                                                  {c.country}
                                                </li>
                                              ))}
                                          </ul>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {states.length > 0 && (
                                <div className="inner-detail-outer">
                                  <div className="inner-detail">
                                    <span className="icon">
                                      <img src={location} alt="Location Icon" />
                                    </span>
                                    <div className="inner-detail-inner">
                                      <label>State *</label>
                                    </div>
                                  </div>
                                  <div className="inner-detail">
                                    <span className="icon"></span>
                                    <div className="inner-detail-inner">

                                      <div className={`custom-dropdown-user-new-outer custom-dropdown-select ${stateDropdownOpen ? 'open' : ''}`} ref={stateDropdownRef}>
                                        <div
                                          className="selected-option custom-dropdown-user-new"
                                          onClick={() => {
                                            setStateDropdownOpen(!stateDropdownOpen);
                                            setStateSearchTerm('');
                                          }}
                                          style={{ cursor: 'pointer' }}
                                        >
                                          {state ? states.find((s) => s.state === state)?.state : 'Select State'}
                                        </div>
                                        {stateDropdownOpen && (
                                          <div className="custom-dropdown-new">
                                            <input
                                              type="text"
                                              className="search-bar"
                                              placeholder="Search..."
                                              value={stateSearchTerm}
                                              onChange={handleStateSearchInputChange}
                                            />
                                            <ul className="state-list">
                                              {filteredStates.length > 0 &&
                                                filteredStates.map((s) => (
                                                  <li
                                                    key={s.state}
                                                    className={state === s.state ? 'selected-item' : ''}
                                                    onClick={() => {
                                                      setState(s.state);
                                                      setStateDropdownOpen(false);
                                                    }}
                                                  >
                                                    {s.state}
                                                  </li>
                                                ))}
                                            </ul>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}

                              <div className="inner-detail-outer">
                                <div className="inner-detail">
                                  <span className="icon">
                                    <img src={location} alt="Location Icon" />
                                  </span>
                                  <div className="inner-detail-inner">
                                    <label>City *</label>
                                  </div>
                                </div>
                                <div className="inner-detail">
                                  <span className="icon"></span>
                                  <div className="inner-detail-inner">
                                    <input type="text" id="city" value={city} onChange={(e) => setCity(e.target.value)} required />
                                  </div>
                                </div>
                              </div>

                              <div className="inner-detail-outer">
                                <div className="inner-detail">
                                  <span className="icon"><img src={location} alt="user icon" /></span>
                                  <div className="inner-detail-inner">
                                    <label htmlFor="address">Address *</label>
                                  </div>
                                </div>
                                <div className="inner-detail">
                                  <span className="icon"></span>
                                  <div className="inner-detail-inner">
                                    <input
                                      type="text"
                                      placeholder="Address"
                                      value={address}
                                      onChange={(e) => setAddress(e.target.value)}
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="information-right">
                              <div className="inner-detail-outer">
                                <div className="inner-detail">
                                  <span className="icon"><img src={PostalCode} alt="user icon" /></span>
                                  <div className="inner-detail-inner">
                                    <label htmlFor="postal_code">Postal Code </label>
                                  </div>
                                </div>
                                <div className="inner-detail">
                                  <span className="icon"></span>
                                  <div className="inner-detail-inner">
                                    <input
                                      type="text"
                                      placeholder="Post Code"
                                      value={pincode}
                                      onChange={(e) => setPincode(e.target.value)}
                                      required
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="inner-detail-outer">
                                <div className="inner-detail">
                                  <span className="icon"><img src={Tele} alt="user icon" /></span>
                                  <div className="inner-detail-inner">
                                    <label htmlFor="number">Mobile No. *</label>
                                  </div>
                                </div>
                                <div className="inner-detail">
                                  <span className="icon"></span>
                                  <div className="inner-detail-inner">
                                    <PhoneInput
                                      placeholder="Enter phone number"
                                      value={mobileNo}
                                      onChange={setMobileNo}
                                      required
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="save-button-sec">
                      {isSubmitLoading ? (
                        <span className="cancel-btn disabled">Cancel</span>
                      ) : (
                        <Link to="/" className="cancel-btn">Cancel</Link>
                      )}
                      <button type="submit" className="save-btn" disabled={isSubmitLoading}>
                        {isSubmitLoading ? (
                          <ButtonSkeleton />
                        ) : (
                          <>
                            <img src={Tick} alt="arrow" />Save changes
                          </>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div >
          </div >
        </div>
      </div>
    </>
  );
}
